
import { Vue, Component, Prop } from 'vue-property-decorator';
import BScroll from 'better-scroll';
import {
  Table,
  TableColumn,
  Button,
  Tag,
  Link,
  DropdownMenu,
  Dropdown,
  DropdownItem,
} from 'element-ui';
import tModal from '@/components/Modal/index.vue';
import { IModalConf } from '@/components/Modal/index.d';
import { ITABLECOLCONF, IBTNCONF } from '@/types/base.d';
import { isExit } from '@/plugin/auth/auth';

@Component({
  components: {
    Table,
    TableColumn,
    Button,
    Tag,
    DropdownMenu,
    Dropdown,
    DropdownItem,
    tModal,
    Link,
  },
})
export default class tTable extends Vue {
  private moreBtns: Array<IBTNCONF> = [];

  private modalConf: IModalConf = {
    title: '图片详情',
    show: false,
    close: () => this.close(),
  };

  private src: string = '';

  @Prop({
    required: true,
  }) datas!: any;

  @Prop({
    required: true,
    default: true,
  }) loading!: boolean;

  @Prop({
    default: false,
  }) expand!: boolean;

  @Prop({
    required: true,
    default: [],
  }) column!: Array<ITABLECOLCONF>;

  @Prop() treeProps?: any;

  @Prop({
    default: false,
  }) selection!: boolean;

  get compColumn() {
    let arrs: Array<ITABLECOLCONF> = [];
    arrs = this.column.filter((arr: ITABLECOLCONF) => arr.btnList && arr.btnList.length >= 0);
    if (arrs && arrs.length > 0) {
      const arr: any = arrs[0];
      const btns: any = arr.btnList.filter((em: any) => isExit(em.name));
      arrs[0].btnList = btns;
      /* eslint-disable no-else-return */
      if (btns.length === 0) return this.column.slice(0, this.column.length - 1);
      /* eslint-disable prefer-template */
      else if (typeof arrs[0].maxBtn === 'undefined' || (btns.length <= (arrs[0].maxBtn || 0))) arr.width = 120 * btns.length + 'px';
      else if (btns.length > (arrs[0].maxBtn || 0)) arr.width = 120 * ((arrs[0].maxBtn || 0) + 1) + 'px';
    }
    return this.column;
  }

  /* eslint-disable class-methods-use-this */
  handleBtnList(btns: Array<IBTNCONF>, maxBtn: number) {
    if (typeof maxBtn === 'number') {
      if (maxBtn > 0 && btns.length > maxBtn) return btns.slice(0, maxBtn);
      else if (maxBtn === 0) return [];
    }
    return btns;
  }

  handleMoreBtns() {
    this.moreBtns = [];
    const btnOperate = this.compColumn.filter((em: any) => em.btnList && em.btnList.length > 0)[0];
    if (btnOperate && btnOperate.btnList && typeof btnOperate.maxBtn === 'number'
      && btnOperate.btnList.length > 0 && btnOperate.btnList.length > btnOperate.maxBtn) {
      this.moreBtns = btnOperate.btnList.slice(btnOperate.maxBtn, btnOperate.btnList.length);
    }
  }

  expandChange(row: any) {
    this.$emit('expandChange', row);
  }

  cellClick(row: any, column: any) {
    this.$emit('cellClick', row, column);
  }

  /**
   * @author liangyongmoou
   * @desc 表格中的图片点击事件
   */
  imgClick(url: string, icon: boolean = false, showBigImg) {
    // if (icon) return;
    console.log(showBigImg);
    if (showBigImg) return;
    this.modalConf.show = true;
    this.src = url;
  }

  handleSelectionChange(row: any) {
    this.$emit('selectionChange', row);
  }

  /**
   * @author liangyongmoou
   * @desc 图片详情模态框关闭事件
   */
  close() {
    this.modalConf.show = false;
  }

  /* eslint-disable class-methods-use-this */
  mounted() {
    this.handleMoreBtns();
    /* eslint-disable no-new */
    new BScroll('#table', {
      scrollY: true,
      click: true,
      preventDefault: false,
      mouseWheel: {
        speed: 20,
        invert: false,
        easeTime: 300,
      },
      scrollbar: {
        fade: false,
      },
    });
  }
}
